<template>
  <v-app class="grey lighten-4">

    <v-main>
      <app-bar/>

      <router-view/>

      <drawer/>
    </v-main>

  </v-app>
</template>

<script>
export default {
  name: "Index",

  components: {
    AppBar: () => import("./components/AppBar"),
    Drawer: () => import("./components/Drawer"),
  },

  data: () => ({
    expandOnHover: true,
  }),
};
</script>
